<template>
  <header>
    <b-row
      class="py-3 dlibr-collapse-unit toggle-trigger"
      v-b-toggle="'accordion-' + deliberation"
    >
      <b-col cols="12" lg="8" class="d-flex">
        <b-icon class="mr-2" icon="chevron-right" variant="primary"></b-icon>
        <strong>
          {{ title }}
        </strong>
      </b-col>
      <b-col cols="12" lg="4" class="text-center text-lg-right mt-3 mt-lg-0">
        <b-row align-h="end">
          <b-col cols="3" sm="4">
            <b-icon
              class="mr-1"
              icon="people-fill"
              variant="secondary"
            ></b-icon>
            <span>{{ totalParticipants }}</span>
          </b-col>
          <b-col cols="3" sm="4">
            <b-icon class="mr-1" icon="chat-fill" variant="secondary"></b-icon>
            <span>{{ totalComments }}</span>
          </b-col>
          <b-col cols="6" sm="4">
            <span>Évaluation {{ getEvaluation | removeDecimals }} %</span>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </header>
</template>

<script>
/**
 * @file       Students collapse header component.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

import { adminStudentMixin } from "@/modules/admin/components/students/mixins";

/**
 * Export the component.
 * 
 * @type  {Object}
 */
export default {
  name: "studentProfileCollapseHeader",
  mixins: [adminStudentMixin],
  props: {
    title: String,
    totalParticipants: Number,
    totalComments: Number,
    deliberation: Number,
    groupId: Number
  },

  /**
   * Computed properties.
   * 
   * @type  {Object}
   */
  computed: {
    /**
     * Get average delibration evaluation.
     *
     * @return     {Mixed}  The total (string or integer).
     */
    getEvaluation: function() {
      var evaluation = this.totalGrades
        .find(tg => tg.group == this.groupId)
        .deliberations.find(u => u.deliberation == this.deliberation);
      return evaluation.avg_deliberation_total
        ? evaluation.avg_deliberation_total
        : "";
    }
  }
};
</script>

<style lang="scss" scoped>
.toggle-trigger[aria-expanded="true"] .bi-chevron-right {
  transform: rotate(90deg);
}
.toggle-trigger .bi-chevron-right {
  transition: 0.3s transform ease-in-out;
}
.main-content {
  border-right: 1px solid rgba(0, 0, 0, 0.1);
}
.body-profile {
  margin-top: 1%;
}
</style>
